export default function PHP_data_seek() {
  return (
    <div>
      <h1>PHP_data_seek</h1>
    </div>
  );
}
